module.exports = __webpack_public_path__ + "img/change.6da3be59.svg";